document.addEventListener('DOMContentLoaded', () => {
  const stack = document.querySelector('.image-stack');
  if (!stack) return;

  let images = Array.from(stack.querySelectorAll('img'));

  function animateStack() {
    images.forEach(img => {
      img.classList.add('fade-out');
    });

    setTimeout(() => {
      const last = images.pop();
      images.unshift(last);
      images.forEach(img => {
        stack.appendChild(img);
      });
    }, 10);

    setTimeout(() => {
      const last = images.pop();
      images.unshift(last);

      images.forEach(img => {
        img.classList.remove('fade-out');
      });
    }, 20);

    setTimeout(animateStack, 5000);
    //must be the same millisecond as fade-out opacity transition
  }

  animateStack();
});
